import { useTranslation } from 'react-i18next';
import { CustomCheckbox } from './../../../../../components/CustomCheckbox';
import {
    CarTitle,
    DetailsIconsOptions,
    DocumentationIcon,
    EmployeesIcon,
    IconBuildingTable,
} from '../../../../../components/buttons/IconButtons';
import DropDownMenuProfile from '../../../../../components/DropDown/DropDownMenuProfile';
import DropDownMenuItem from '../../../../../components/DropDown/DropDownMenuItem';
import routes from '../../../../../Routes/routes';
import { useNavigate } from 'react-router-dom';
import { EMPTY_VALUES } from '../../../../../Apis/functions';
import TableFunction from '../../../../../components/table/TableFunction';
import NotInformation from '../../../../../components/NotInformation';
import {PROFILE_MODEL} from '../../../../DocumentationApprovalFlow/Model/Model';
import {CONTRACTORS_SUBVIEW_MODEL, TABS_CONTRACTORS} from '../../Model/Models';
import {USER_TYPE_MODEL} from '../../../../../enums/userTypeEnum';
import {PROVIDER_SUB_VIEW_MODEL, TABS_PROVIDER} from '../../../../Provider/Model/Model';
import {permissionObj} from "../../../../../Helpers/permission";
import {useSelector} from "react-redux";

/**
 * @Author      Jhovanny Fragoso Marquez
 * @JobTitle    Frontend Developer
 * @Email       jfragoso@ibl.mx
 */

const RenderExpandedRow = ({ row, onSelectItem, selectedList = [], canApprove, userTypeId }) => {
    const DEV = useSelector((state) => state?.CommonsSlice?.development); // Get development flag from Redux state
    const { permission } = useSelector((state) => state.authenticatioauthennSlice); // Get user permissions from Redux state
    const { t } = useTranslation();
    const navigate = useNavigate();
    const noData =
        (!row?.companyRequest || row.companyRequest.length === 0) &&
        (!row?.employeeRequest || row.employeeRequest.length === 0) &&
        (!row?.vehicleRequest || row.vehicleRequest.length === 0);

    const getActionsButtons = (item, profile, index) => {
        const { openMenu, handleMenuToggle } = TableFunction({});
        return (
            <>
                {(DEV || (permission?.includes(permissionObj.WEB_CONTRACTOR_REQUEST_MANAGE)
                    || permission?.includes(permissionObj.WEB_SUPPLIER_REQUEST_MANAGE)))
                && item ? (
                    <DropDownMenuProfile
                        openMenu={openMenu}
                        handleMenuToggle={handleMenuToggle}
                        menuId={`menu-${item.id}`}
                    >
                        {item && (
                            <DropDownMenuItem
                                index={index}
                                handleClose={() => { }}
                                name={t('details')}
                                icon={<DetailsIconsOptions />}
                                click={() => {
                                    const isContractor = userTypeId === USER_TYPE_MODEL.CONTRACTOR_IN_CHARGE;
                                    const isVehicle = profile === PROFILE_MODEL.VEHICLE;

                                    const baseRoute = isContractor ? routes.employee.documentRequestDetailsContractor : routes.employee.documentRequestDetailsSupplier;
                                    const id = isVehicle ? item?.vehicleId : item?.userId;
                                    const subView = isContractor ? CONTRACTORS_SUBVIEW_MODEL.DOCUMENTATION.REQUESTS : PROVIDER_SUB_VIEW_MODEL.DOCUMENTATION.REQUESTS;

                                    navigate(`${baseRoute}${id}/${profile}`, {
                                        state: {
                                            currentTab: isContractor ? TABS_CONTRACTORS.DOCUMENTATION.INDEX :TABS_PROVIDER.DOCUMENTATION.INDEX,
                                            currentSubView: subView,
                                            userType: userTypeId, 
                                            
                                        },
                                    });
                                }}
                            />
                        )}
                    </DropDownMenuProfile>
                ) : (
                    EMPTY_VALUES.DEFAULT
                )}
            </>
        );
    };

    const RowElement = (props) => {
        const { profile= '', el, getActionsButtons, index, showCheckBox = true, isMatchDepartment = false, isChecked = false, handleCheckbox = () => { } } = props;
        const { t } = useTranslation();
        return (
            <div
                key={el.id}
                onClick={(e) => e.stopPropagation()}
                className={`
                col-12 d-flex background-shades-100 mt-2 py-2 border-radius-8px border-full-shades-200 justify-content-between align-items-center position-relative
                ${isMatchDepartment ? 'background-secondary-50 border-full-secondary-400  py-0' : ''}
            `}
            >
                <div className='fw-bolder no-padding'>
                    {showCheckBox && (
                        <CustomCheckbox
                            id={`cb_rer_${el.id}`}
                            checked={isChecked}
                            disabled={!showCheckBox}
                            onChange={handleCheckbox}
                            onClick={(e) => e.stopPropagation()}
                            className={'p-0'}
                        />
                    )}
                    { PROFILE_MODEL.VEHICLE === profile ?
                        <>{ `${el?.brand} ${el.subBrand} - ${el?.plates}` }</>
                        :
                        <>{el?.fullName}</>
                    }
                </div>
                <div className={`d-flex gap-2 align-items-center no-padding ${showCheckBox ? 'pl-2' : ''}`}>
                    <div><DocumentationIcon height={16} width={16} className='icon-color-shades-600' /></div>
                    <p className="font-color-shades-600">{el?.numberDocuments}</p>
                    <p className="font-color-shades-600">{t('documents')}</p>
                    {getActionsButtons(el, profile, index)}
                </div>
            </div>
        );
    };

    return (
        <>
            {row?.companyRequest?.length > 0 && row?.numberDocuments > 0 && (
                <>
                    <div className='d-flex border-bottom-shades-300 pb-2'>
                        <div className='col-12 fs-14px ibl-font-w-600'>
                            <IconBuildingTable className='mr-2' />
                            {t('company_request')}
                        </div>
                    </div>
                    {row?.companyRequest?.length > 0 ? (
                        row.companyRequest.map((el, index) => (
                            <RowElement
                                profile={PROFILE_MODEL.COMPANY}
                                key={el.id}
                                el={el}
                                index={index}
                                getActionsButtons={getActionsButtons}
                                isChecked={selectedList.includes(el.id)}
                                handleCheckbox={() => {
                                    if (!canApprove) return;
                                    const newState = !selectedList.includes(el.id);
                                    onSelectItem(el.id, newState);
                                }}
                                isMatchDepartment={el?.matchDepartment}
                                showCheckBox={el?.canApprove}
                            />
                        ))
                    ) : (
                        <NotInformation text={t('no_company_request')} card={true} />
                    )}
                </>
            )}

            {row?.employeeRequest?.length > 0 && (
                <>
                    <div className='d-flex border-bottom-shades-300 pb-2 mt-4'>
                        <div className='col-12 fs-14px ibl-font-w-600'>
                            <EmployeesIcon className='mr-2' />
                            {t('employee_request')}
                        </div>
                    </div>
                    {row?.employeeRequest?.length > 0 ? (
                        row.employeeRequest.map((el, index) => (
                            <RowElement
                                profile={PROFILE_MODEL.EMPLOYEE}
                                key={el.id}
                                el={el}
                                index={index}
                                getActionsButtons={getActionsButtons}
                                isChecked={selectedList.includes(el.id)}
                                handleCheckbox={() => {
                                    const newState = !selectedList.includes(el.id);
                                    onSelectItem(el.id, newState);
                                }}
                                isMatchDepartment={el?.matchDepartment}
                                showCheckBox={el?.canApprove}
                            />
                        ))
                    ) : (
                        <NotInformation text={t('no_employee_request')} card={true} />
                    )}
                </>
            )}

            {row?.vehicleRequest?.length > 0 && (
                <>
                    <div className='d-flex border-bottom-shades-300 pb-2 mt-4'>
                        <div className='col-12 fs-14px ibl-font-w-600'>
                            <CarTitle className='mr-2' />
                            {t('vehicle_request')}
                        </div>
                    </div>
                    {row?.vehicleRequest?.length > 0 ? (
                        row.vehicleRequest.map((el, index) => (
                            <RowElement
                                profile={PROFILE_MODEL.VEHICLE}
                                key={el.id}
                                el={el}
                                index={index}
                                getActionsButtons={getActionsButtons}
                                isChecked={selectedList.includes(el.id)}
                                handleCheckbox={() => {
                                    const newState = !selectedList.includes(el.id);
                                    onSelectItem(el.id, newState);
                                }}
                                isMatchDepartment={el?.matchDepartment}
                                showCheckBox={el?.canApprove}
                            />
                        ))
                    ) : (
                        <NotInformation text={t('no_vehicle_request')} card={true} />
                    )}
                </>
            )}
            {noData && <NotInformation text={t('no_requests_found')} card={true} />}
        </>
    );
};

export default RenderExpandedRow;
